import React, { useEffect, useState } from 'react'
import { BackButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { GetAccess } from '../../../../Components/Utils/roles';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';


const InSchedulelayout = ({
  getData = () => {},
  setSearchQuery = () => {},
  EditAccess = false,
  ImportAccess = false,
  setOpen = () => {},
  setOpenExport = () => {},
  children,
  onCreateClick,
  searchValue = "",
  searchFun = () => {},
  isFilter = false,
  setFilterOpen = () => {},
  newfilter = false,
  ClearFilter = () => {},
  neededSearch = false,
  showproject = true,
  isCard = true,
  setViewMode = () => {},
  viewMode = "",
  ExportAccess = false,
}) => {
  const location = useLocation();
  const data = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;
  const [percentOpen, setPercentOpen] = useState(false);
  const fromDashboard = location.state?.fromDashboard === true;

  let { pathname } = useLocation();
  const [module, setModule] = useState("");
  const navigate = useNavigate();
  const { scheduleViewId} = useParams();

  const from = location.state?.from || -1; 

  console.log("from",from);

  let searchList = [
    { value: "all", label: "All" },
    { value: "services", label: "Services" },
    { value: "products", label: "Products" },
  ];

  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    if (pathname == `/inspection/schedule/view/${scheduleViewId}`) {
      setModule("Details");
    }
    //  else if (
    //   pathname == `/inspection/schedule/form/${scheduleViewId}`
    // ) {
    //   setModule("Forms");
    // }
    else if (
        pathname == `/inspection/schedule/newform/${scheduleViewId}`
      ) {
        setModule("Inspection Forms");
      }

        else if (
        pathname == `/inspection/schedule/generator/${scheduleViewId}`
      ) {
        setModule("Generator");
      }

      
  }, [pathname]);

  let LinkItem = [
    {
      label: "Details",
      link: `/inspection/schedule/view/${scheduleViewId}`,
      access: true,
    },
    // {
    //   label: "Inspection Forms",

    //   link: `/inspection/schedule/form/${scheduleViewId}`,
    //   access: GetAccess('inspection_schedule_form_view'),
    // },
    {
        label: "Inspection Forms",
  
        link: `/inspection/schedule/newform/${scheduleViewId}`,
        access: GetAccess(),
      },

      // {
      //   label: "Generator",
      //   link: `/inspection/schedule/generator/${scheduleViewId}`,
      //   access: GetAccess(),
      // },

  ];

  

  return (
    <div className=" w-full  h-full py-2 px-4 md:overflow-hidden">
      <div className="flex justify-between w-full ">
       

        {/* <div className=" flex justify-end items-center gap-3 ">
         
        </div> */}
        <div className="sm:flex justify-between w-full">
        <Breadcrumb
          items={[
            // { name: "Inspection" },
            {
              name: "Schedule",
              link:"/inspection/schedule"

             
            },

            { name: module },
          ]}
        />
 <div className=" flex gap-2 justify-end">
            {/* <Link
              to={`/inspection/schedule`}
              state={{
                currentPage: pageIndex,
                searchQuery: searchQuery != "" ? searchQuery : "",
              }}
            >
              <BackButton />
            </Link> */}

            <BackButton
                link={true}
                hasLink={
                  fromDashboard
                    ? "/dashboard"
                    : module === "Inspection Forms"
                    ? `/inspection/schedule/view/${scheduleViewId}`
                 
                    : module !== "Details"
                    ? `/inspection/schedule`
                       : `/inspection/schedule`
                }
                state={
                  !fromDashboard && module === "Details"
                    ? {
                        currentPage: pageIndex,
                        searchQuery: searchQuery !== "" ? searchQuery : "",
                      }
                    : null
                }
              />

             {/* <BackButton
                                      link={true}
                                      hasLink={
                                        module !== "Details"
                                          ? `/inspection/schedule/view/${scheduleViewId}`
                                          : `/inspection/schedule`
                                      }
                                      state={
                                        module === "Details"
                                          ? {
                                              currentPage: pageIndex,
                                              searchQuery: searchQuery !== "" ? searchQuery : "",
                                            }
                                          : null
                                      }
                                    /> */}
            {EditAccess && (
              <Link
                to={`/inspection/schedule/edit/${scheduleViewId}`}
                state={{
                  data: data,
                  from: `/inspection/schedule/view/${scheduleViewId}`,
                }}
              >
                <EditButton
                 height="8" />
              </Link>
            )}
          </div>
       
        </div>
      </div>
      <div className=" w-full  flex items-center gap-x-1 ">
          {LinkItem &&
            LinkItem.map((item, i) => {
      const isActive = item?.link === pathname;

              return (
                <>
                  {item.access && (

                      <Link
                                                                                                    to={item?.link}
                                                                                                    key={item?.link}
                                                                                                    state={{fromDashboard:fromDashboard}}
                                                                                                    className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                                                                                                      ${isActive 
                                                                                                        ? "bg-baseColor-primary text-white" 
                                                                                                        : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                                                                                                      }`}
                                                                                                  >
                                                                                                    {item?.label || ""}
                                                                                                  </Link>
                    // <Link
                    //   to={item?.link}
                    //   className={`mx-3 pb-1 text-xs 2xl:text-sm font-medium text-baseColor-primary ${
                    //     item?.link == pathname
                    //       ? "border-b-2 border-baseColor-primary"
                    //       : "border-b-2 border-transparent"
                    //   }   `}
                    //   key={item?.link}
                    // >
                    //   {item?.label || ""}
                    // </Link>
                  )}
                </>
              );
            })}
        </div>
      <div className=" w-full h-[calc(100vh-160px)]  ">{children}</div>
    </div>
  );
};



export default InSchedulelayout